import i18n, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // 초기 언어(fallback)
    fallbackLng: "ko",
    supportedLngs: ["ko", "en"],
    ns: ["common"], // 사용 네임스페이스
    defaultNS: "common",

    // 브라우저 언어 감지 & 저장
    detection: {
      order: [
        "querystring",
        "path",
        "localStorage",
        "navigator",
        "htmlTag",
        "cookie",
      ],
      caches: ["localStorage"],
    },

    // 백엔드(지연 로딩) 경로
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    // 성능/디버깅 옵션
    // debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false, // React는 XSS 자체 방어
    },

    // React 전용 옵션
    react: {
      useSuspense: true,
    },
  });

export type AppLng = "ko" | "en";
export default i18n;
